import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DwConfigService, DwConfigServiceToken, DwSecurityContext, DwSecurityUserService } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';
import { CourseAssignmentOutcome } from '../models/course-assignment-outcome.model';

@Injectable({ providedIn: 'root' })
export class CourseAssignmentOutcomeService {
  private readonly apiRoot: string;
  private pendingRequest: Observable<CourseAssignmentOutcome[]>;
  private pendingSecurityContext: DwSecurityContext;
  constructor(
    @Inject(DwConfigServiceToken) dwConfigService: DwConfigService,
    private readonly httpClient: HttpClient,
    private readonly securityUserService: DwSecurityUserService
  ) {
    this.apiRoot = `${dwConfigService.coreConfig.apiRoot}/aviator-online/students/activity`;
  }

  getUnacknowledgedCourseAssignments(): Observable<CourseAssignmentOutcome[]> {
    const securityContext = this.securityUserService.securityContext;
    if (this.pendingRequest && this.pendingSecurityContext === securityContext) {
      return this.pendingRequest;
    }

    // Share overlapping dashboard loads, but do not cache completed results or cross security contexts.
    const request = this.httpClient.get<CourseAssignmentOutcome[]>(`${this.apiRoot}/unacknowledged-course-assignments`).pipe(
      finalize(() => {
        if (this.pendingRequest === request) {
          this.pendingRequest = null;
          this.pendingSecurityContext = null;
        }
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    );
    this.pendingSecurityContext = securityContext;
    this.pendingRequest = request;
    return request;
  }

  acknowledgeCourseAssignments(outcomes: CourseAssignmentOutcome[]): Observable<object> {
    return this.httpClient.post(`${this.apiRoot}/acknowledge-course-assignments`, {
      StudentActivityIds: outcomes.map(outcome => outcome.StudentActivityId)
    });
  }
}
